import BookDemoModal from 'components/modals/BookDemoModal';
import { useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';

function Demo() {
  const [show, setShow] = useState(false);
  return (
    <Container fluid className="bg-body-highlight pb-14">
      <BookDemoModal show={show} onClose={() => setShow(false)} />
      <Row className="demoBG mx-3 d-flex align-items-center justify-content-center">
        <Col
          lg={12}
          className="d-flex flex-column align-items-center justify-content-center"
        >
          <p className="fs-4 fw-bold text-white">
            Trust CRUD Beat for Efficient Hiring and Training
          </p>
          <p className="m-0 fs-8 text-white">
            Join countless institutions and employers who rely on our platform
            for seamless
          </p>
          <p className="fs-8 text-white mb-6">
            hiring processes and effective student training.
          </p>
          <Button className="py-3" onClick={() => setShow(true)}>
            Book Demo
          </Button>
        </Col>
      </Row>
    </Container>
  );
}

export default Demo;
